import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, unref as _unref, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-89e845b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "task-content" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Click Next to sign up! ", -1))
const _hoisted_4 = { key: 2 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Sign up now, and we'll get you in as soon as we can! ", -1))

import { computed, onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { usePageTitle } from '@webapp/util/AppUtil'
import { useSignInStore } from '@webapp/auth/SignInStore'
import { BlockGrant, useIdentityApi } from './IdentityApi'
import { useIdentityBlockGrantStore } from './IdentityBlockGrantStore'
import { Environment } from '@webapp/util/Environment'
import { pluralizeWithCount } from '@/util/LanguageUtil'
import TaskPage from '@/util/TaskPage.vue'
import LoadingIndicator from '@/util/LoadingIndicator.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SignUpInvitedPage',
  setup(__props) {

const loadingRef = ref(false)
const signInRestrictedRef = ref(false)
const blockGrantRef = ref<BlockGrant>()

usePageTitle("Sign up")

const router = useRouter()
const signInStore = useSignInStore()
const identityApi = useIdentityApi()
const blockGrantStore = useIdentityBlockGrantStore()

const sourceIconRef = computed(() => blockGrantRef.value?.sourceIcon ? `${Environment.get('INTEGRATION_CONTENT_URL')}/${blockGrantRef.value.sourceIcon}` : undefined)
const remainingTextRef = computed(() => signInStore.unusedGrant > 10 ? "at least 10 spots" : pluralizeWithCount(signInStore.unusedGrant, ['spot', 'spots']))

onMounted(async () => {
  try {
    loadingRef.value = true
    blockGrantRef.value = undefined

    signInStore.couponCode = router.currentRoute.value.query.code as string
    if (signInStore.couponCode) {
      blockGrantRef.value = await blockGrantStore.getBlockGrantAsync(signInStore.couponCode)
      signInStore.unusedGrant = blockGrantRef.value ? blockGrantRef.value.allocated - blockGrantRef.value.used : 0
    }
    signInRestrictedRef.value = await identityApi.isSignInRestrictedAsync()
  }
  finally {
    loadingRef.value = false
  }

  if (!blockGrantRef.value) {
    nextStep(true)
  }
})

function nextStep(replace = false) {
  const next = "/signup"
  if (replace) {
    router.replace(next)
  } else {
    router.push(next)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TaskPage, {
    class: "signup-invited-page",
    "no-back": "",
    "can-continue": "",
    onAction: _cache[0] || (_cache[0] = ($event: any) => (nextStep()))
  }, {
    title: _withCtx(() => [
      _createTextVNode("Get started")
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (loadingRef.value)
          ? (_openBlock(), _createBlock(LoadingIndicator, { key: 0 }))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (sourceIconRef.value)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: sourceIconRef.value
                  }, null, 8, _hoisted_2))
                : _createCommentVNode("", true),
              (!signInRestrictedRef.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", null, [
                      _createTextVNode(" Thanks for visiting us from "),
                      _createElementVNode("b", null, _toDisplayString(blockGrantRef.value?.sourceName), 1),
                      _createTextVNode(". ")
                    ]),
                    _hoisted_3
                  ], 64))
                : (_unref(signInStore).unusedGrant)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createTextVNode(" Thanks for visiting us from "),
                      _createElementVNode("b", null, _toDisplayString(blockGrantRef.value?.sourceName), 1),
                      _createTextVNode(". This invitation group currently has " + _toDisplayString(remainingTextRef.value) + " remaining. ", 1)
                    ]))
                  : (blockGrantRef.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                        _createElementVNode("div", null, [
                          _createTextVNode(" Thanks for visiting us from "),
                          _createElementVNode("b", null, _toDisplayString(blockGrantRef.value?.sourceName), 1),
                          _createTextVNode("! Unfortunately, there are no more spots left in this invitation group. ")
                        ]),
                        _hoisted_5
                      ], 64))
                    : _createCommentVNode("", true)
            ], 64))
      ])
    ]),
    _: 1
  }))
}
}

})